import { gql } from "@apollo/client"
import { type ProjectConfigType } from "@tutellus/dappcomposer-contracts-ifaces"

export const GET_PROJECT_CONFIG_QUERY = gql`
  query GET_PROJECT_CONFIG_QUERY {
    getProjectConfiguration {
      __typename
      ... on ProjectConfig {
        id
        key
        chainID
        tokens {
          id
          name
          symbol
          decimals
          type
          metadata {
            permitted
            domainName
            domainVersion
            swapFeeType
          }
        }
        pools {
          id
          name
          symbol
          decimals
          type
          tokens
          multiplier
          metadata {
            permitted
            domainName
            domainVersion
            swapFeeType
          }
        }
        addresses {
          tokenID
          address
          feed
        }
        externalSources {
          uri
          purposes
        }
        balances
        dexRouters {
          id
          address
          type
        }
        synthetics {
          id
          escrowedTokenId
          type
          vaultAddress
          voterAddress
          rebaseAddress
          epochDuration
          minLockDuration
          maxLockDuration
          minterAddress
        }
        gauges {
          poolID
          address
          rewardTokenID
        }
        bribes {
          poolID
          address
        }
      }
      ... on SimpleError {
        description
      }
    }
  }
`

export type GetProjectConfigQueryResponse = {
  getProjectConfiguration: ProjectConfigType
}
